/**
 * Notification Management System with Real-time Socket Support
 * @author เต้ย
 */
class NotificationManager extends Template {
    constructor() {
        super();
        this.notifications = {
            my: []
        };
        this.unreadCount = 0;
        this.isLoading = {
            my: false
        };
        this.currentPage = {
            my: 1
        };
        this.hasMorePages = {
            my: true
        };
        // Socket support
        this.socketInitialized = false;
        // Filter state
        this.currentFilter = 'all';
        // Cache unread count กัน page-load ทุกหน้ายิง HTTP ซ้ำ (socket เป็น source of truth)
        this.unreadCacheTtl = 5 * 60 * 1000;

        this.init();
    }

    init() {
        this.bindEvents();
        this.hydrateUnreadFromCache();
        if (window._skipInitialUnreadCount !== true && this.isUnreadCacheStale()) {
            this.loadUnreadCount();
        }
        this.initSocket();
    }

    unreadCacheKey() {
        return 'notif_unread_' + (this.user_id || 'anon');
    }

    hydrateUnreadFromCache() {
        try {
            const raw = localStorage.getItem(this.unreadCacheKey());
            if (!raw) return;
            const cached = JSON.parse(raw);
            if (cached && typeof cached.c === 'number') {
                this.unreadCount = cached.c;
                this.updateBadge();
            }
        } catch (e) {}
    }

    isUnreadCacheStale() {
        try {
            const raw = localStorage.getItem(this.unreadCacheKey());
            if (!raw) return true;
            const cached = JSON.parse(raw);
            return !cached || typeof cached.t !== 'number' || (Date.now() - cached.t) > this.unreadCacheTtl;
        } catch (e) {
            return true;
        }
    }

    persistUnreadCache() {
        try {
            localStorage.setItem(this.unreadCacheKey(), JSON.stringify({ c: this.unreadCount, t: Date.now() }));
        } catch (e) {}
    }

    setUnreadCount(count) {
        this.unreadCount = typeof count === 'number' ? count : parseInt(count, 10) || 0;
        this.updateBadge();
    }

    bindEvents() {
        // เปิด notification drawer
        $('#kt_drawer_chat_toggle').on('click', () => {
            this.loadNotifications();
        });

        // ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว
        $('#btn-mark-all-read').on('click', () => {
            this.markAllAsRead();
        });

        // ลบ Tab switching เนื่องจากไม่มี Timeline แล้ว

        // Refresh notifications
        $(document).on('click', '.refresh-notifications', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.refreshNotifications();
        });

        // Filter notifications - ใช้ event delegation
        $(document).on('click', '.notification-filter', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const filter = $(e.currentTarget).data('filter');
            this.applyFilter(filter);
        });

        // Scroll to load more
        $('#kt_activities_scroll').on('scroll', (e) => {
            const element = e.target;
            if (element.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
                this.loadMoreNotifications();
            }
        });
    }

    /**
     * ดึงจำนวน notifications ที่ยังไม่อ่าน
     */
    async loadUnreadCount() {
        const { data: response } = await this._axiosClient.get('notification/api/get_unread_count', {}, {
            skipLoading: true
        });

        if (response.success) {
            this.unreadCount = response.data.unread_count || 0;
            this.updateBadge();
        }
    }

    /**
     * ดึงรายการ notifications
     */
    async loadNotifications(page = 1) {
        if (this.isLoading.my) return;

        this.isLoading.my = true;
        this.showLoading();

        try {
            const params = {
                page: page,
                limit: 20
            };

            // เพิ่ม filter parameter ถ้าไม่ใช่ 'all'
            if (this.currentFilter && this.currentFilter !== 'all') {
                params.type = this.currentFilter;
            }

            const { data: response } = await this._axiosClient.get('notification/api/get_notifications', params, {
                skipLoading: true
            });

            if (response.success) {
                if (page == 1) {
                    this.notifications.my = response.data.data || [];
                } else {
                    this.notifications.my = [...this.notifications.my, ...(response.data.data || [])];
                }

                if (response.data.pagination) {
                    this.currentPage.my = response.data.pagination.page;
                    this.hasMorePages.my = this.currentPage.my < response.data.pagination.totalPages;
                }

                this.renderNotifications();
            } else {
                this.showError('ไม่สามารถโหลดการแจ้งเตือนได้');
            }
        } catch (error) {
            this.showError('เกิดข้อผิดพลาดในการโหลดข้อมูล');
        } finally {
            this.isLoading.my = false;
            this.hideLoading();
        }
    }

    /**
     * โหลด notifications เพิ่มเติม
     */
    async loadMoreNotifications() {
        if (!this.hasMorePages.my || this.isLoading.my) return;

        await this.loadNotifications(this.currentPage.my + 1);
    }

    /**
     * แสดง notifications ในรายการ
     */
    renderNotifications() {
        const container = $('#notifications-list');

        // ตรวจสอบและสร้าง array ถ้ายังไม่มี
        if (!this.notifications.my) {
            this.notifications.my = [];
        }

        const notifications = this.notifications.my;

        if (notifications.length == 0) {
            $('#notifications-empty').show();
            container.hide();
            return;
        }

        $('#notifications-empty').hide();
        container.show();

        let html = '';
        notifications.forEach(notification => {
            html += this.renderNotificationItem(notification);
        });

        container.html(html);
        this.bindNotificationEvents();
    }

    /**
     * สร้าง HTML สำหรับ notification แต่ละรายการ
     */
    renderNotificationItem(notification) {
        const isUnread = !notification.is_read;
        const timeAgo = this.getTimeAgo(notification.created_at);
        const icon = this.getNotificationIcon(notification.notification_module, notification.notification_type);
        const bgClass = isUnread ? 'bg-light-primary' : '';

        return `
            <div class="d-flex flex-stack py-4 notification-item ${bgClass}" data-notification-id="${notification.notification_id}" data-is-read="${notification.is_read}">
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-35px me-4">
                        <span class="symbol-label bg-light-${this.getNotificationColor(notification.notification_priority)}">
                            ${icon}
                        </span>
                    </div>
                    <div class="mb-0 me-2">
                        <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold notification-title">
                            ${notification.notification_title}
                        </a>
                        <div class="text-gray-800 fs-7 notification-message">
                            ${notification.notification_message}
                        </div>
                        <div class="text-gray-800 fs-8 mt-1">
                            <i class="far fa-clock me-1"></i>
                            ${timeAgo}
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column align-items-end">
                    ${isUnread ? '<span class="bullet bullet-dot bg-primary h-6px w-6px"></span>' : ''}
                    <div class="dropdown">
                        <button class="btn btn-sm btn-icon btn-light btn-active-light-primary" data-bs-toggle="dropdown">
                            <i class="fas fa-ellipsis-v"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-end">
                            ${isUnread ? '<a class="dropdown-item mark-as-read" href="#"><i class="fas fa-check me-2"></i>ทำเครื่องหมายว่าอ่านแล้ว</a>' : ''}
                            <a class="dropdown-item view-detail" href="#"><i class="fas fa-eye me-2"></i>ดูรายละเอียด</a>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    /**
     * ผูก events สำหรับ notification items
     */
    bindNotificationEvents() {
        // ทำเครื่องหมายว่าอ่านแล้ว
        $('#notifications-list .mark-as-read').off('click').on('click', (e) => {
            e.preventDefault();
            const notificationId = $(e.target).closest('.notification-item').data('notification-id');
            this.markAsRead([notificationId]);
        });

        // ดูรายละเอียด
        $('#notifications-list .view-detail').off('click').on('click', (e) => {
            e.preventDefault();
            const notificationId = $(e.target).closest('.notification-item').data('notification-id');
            this.viewNotificationDetail(notificationId);
        });

        // คลิกที่ notification เพื่อดูรายละเอียด
        $('#notifications-list .notification-item').off('click').on('click', (e) => {
            if ($(e.target).closest('.dropdown').length == 0) {
                const notificationId = $(e.currentTarget).data('notification-id');
                this.viewNotificationDetail(notificationId);
            }
        });
    }

    /**
     * ทำเครื่องหมายว่าอ่านแล้ว
     */
    async markAsRead(notificationIds) {
        const { data: response } = await this._axiosClient.post('notification/api/mark_as_read', {
            notification_ids: notificationIds
        }, {
            skipLoading: true
        });

        if (response.success) {
            // อัพเดท UI
            notificationIds.forEach(id => {
                const item = $(`.notification-item[data-notification-id="${id}"]`);
                item.removeClass('bg-light-primary');
                item.data('is-read', true);
                item.find('.bullet').remove();
                item.find('.mark-as-read').parent().remove();
            });

            // อัพเดทจำนวนที่ยังไม่อ่าน
            this.unreadCount = Math.max(0, this.unreadCount - notificationIds.length);
            this.updateBadge();

            this._moduleToast.success('ทำเครื่องหมายว่าอ่านแล้ว');
        }
    }

    /**
     * ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว
     */
    async markAllAsRead() {
        const { data: response } = await this._axiosClient.post('notification/api/mark_all_as_read', {
            module: 'ticket' // สามารถกรองตาม module ได้
        }, {
            skipLoading: true
        });

        if (response.success) {
            // อัพเดท UI
            $('.notification-item').removeClass('bg-light-primary');
            $('.notification-item').data('is-read', true);
            $('.bullet').remove();
            $('.mark-as-read').parent().remove();

            this.unreadCount = 0;
            this.updateBadge();

            this._moduleToast.success('ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว');
        }
    }

    /**
     * ดูรายละเอียด notification
     */
    viewNotificationDetail(notificationId) {
        // ตรวจสอบและสร้าง array ถ้ายังไม่มี
        if (!this.notifications.my) {
            this.notifications.my = [];
        }

        const notification = this.notifications.my.find(n => n.notification_id == notificationId);
        if (!notification) return;

        // ทำเครื่องหมายว่าอ่านแล้ว (ถ้ายังไม่อ่าน)
        if (!notification.is_read) {
            this.markAsRead([notificationId]);
        }

        // นำทางไปยังหน้าที่เกี่ยวข้อง
        if (notification.notification_data && notification.notification_data.ticket_id) {
            // ไปยังหน้า ticket detail
            window.open(`${this.baseUrl}ticket?ticket_id=${notification.notification_data.ticket_id}`, '_blank');
        }
    }

    /**
     * อัพเดท badge แสดงจำนวนที่ยังไม่อ่าน
     */
    updateBadge() {
        this.persistUnreadCache();
        // อัพเดท badge หลัก
        const badge = $('#notification-badge');
        if (this.unreadCount > 0) {
            badge.show();
            badge.text(this.unreadCount > 99 ? '99+' : this.unreadCount);
        } else {
            badge.hide();
        }

        // อัพเดท app badge (PWA)
        if ('setAppBadge' in navigator) {
            if (this.unreadCount > 0) {
                navigator.setAppBadge(this.unreadCount).catch(() => {});
            } else {
                navigator.clearAppBadge().catch(() => {});
            }
        }
    }

    /**
     * แสดง loading state
     */
    showLoading() {
        $('#notifications-loading').show();
        $('#notifications-list').hide();
        $('#notifications-empty').hide();
    }

    /**
     * ซ่อน loading state
     */
    hideLoading() {
        $('#notifications-loading').hide();
    }

    /**
     * แสดงข้อความ error
     */
    showError(message) {
        $('#notifications-loading').hide();
        $('#notifications-list').hide();
        $('#notifications-empty').show();
        $('#notifications-empty').html(`
            <i class="fas fa-exclamation-circle fs-3x text-danger mb-3"></i>
            <div class="text-danger fs-6">${message}</div>
        `);
    }

    /**
     * เริ่มการอัพเดทแบบ periodic
     */
    startPeriodicUpdate() {
        // อัพเดทจำนวนที่ยังไม่อ่านทุก 30 วินาที (ถ้าไม่มี socket)
        if (!this.socketInitialized) {
            this.loadUnreadCount();
        }
    }

    /**
     * เริ่มต้น Socket connection
     */
    initSocket() {
        if (this._moduleSocket && this.user_id) {
            this._moduleSocket.init();
            this._moduleSocket.join('notification');
            this.setupSocketEvents();
            this.socketInitialized = true;
        }
    }

    /**
     * ตั้งค่า Socket Events
     */
    setupSocketEvents() {
        if (!this._moduleSocket) return;

        // รับ notification ใหม่
        this._moduleSocket.on('newNotification', (data) => {
            this.handleNewNotification(data);
        });

        // อัพเดทจำนวน notification
        this._moduleSocket.on('notificationCountUpdate', (data) => {
            this.handleCountUpdate(data);
        });
    }

    /**
     * จัดการ notification ใหม่
     */
    handleNewNotification(data) {
        // ตรวจสอบและสร้าง array ถ้ายังไม่มี
        if (!this.notifications.my) {
            this.notifications.my = [];
        }

        // เพิ่มใน my notifications ถ้าเป็นของตัวเอง
        if (data.toUserId == this.user_id) {
            this.notifications.my.unshift(data);
            this.playNotificationSound();
        }

        // อัพเดท UI ถ้าเปิดอยู่
        if ($('#kt_drawer_chat').hasClass('drawer-on')) {
            this.renderNotifications();
        }
    }

    /**
     * จัดการอัพเดทจำนวน
     */
    handleCountUpdate(data) {
        if (data.userId == this.user_id) {
            this.unreadCount = data.unread_count;
            this.updateBadge();
        }
    }


    playNotificationSound() {
        const soundEnabled = localStorage.getItem('notification_sound') !== 'off';
        if (!soundEnabled) return;
        try {
            const audio = new Audio(this.baseUrl + 'assets/backend/audio/notification.wav');
            audio.volume = 0.5;
            audio.play().catch(() => {});
        } catch (e) {}
    }

    /**
     * รีเฟรช notifications
     */
    refreshNotifications() {
        // ตรวจสอบและสร้าง array ถ้ายังไม่มี
        if (!this.notifications.my) {
            this.notifications.my = [];
        }
        if (!this.currentPage.my) {
            this.currentPage.my = 1;
        }
        if (!this.hasMorePages.my) {
            this.hasMorePages.my = true;
        }

        this.notifications.my = [];
        this.currentPage.my = 1;
        this.hasMorePages.my = true;
        this.loadNotifications();
        this.loadUnreadCount();
    }

    /**
     * ได้ icon สำหรับ notification
     */
    getNotificationIcon(module, type) {
        const icons = {
            'ticket': {
                'created': '<i class="fas fa-plus"></i>',
                'updated': '<i class="fas fa-edit"></i>',
                'commented': '<i class="fas fa-comment"></i>',
                'assigned': '<i class="fas fa-user-plus"></i>',
                'state_changed': '<i class="fas fa-exchange-alt"></i>',
                'member_removed': '<i class="fas fa-user-minus"></i>',
                'deleted': '<i class="fas fa-trash"></i>',
                'restored': '<i class="fas fa-undo"></i>'
            },
            'system': {
                'maintenance': '<i class="fas fa-tools"></i>',
                'announcement': '<i class="fas fa-bullhorn"></i>'
            }
        };

        return icons[module]?.[type] || '<i class="fas fa-bell"></i>';
    }

    /**
     * ได้สีสำหรับ notification
     */
    getNotificationColor(priority) {
        const colors = {
            'low': 'info',
            'normal': 'primary',
            'high': 'warning',
            'urgent': 'danger'
        };

        return colors[priority] || 'primary';
    }

    /**
     * คำนวณเวลาที่ผ่านมา
     */
    getTimeAgo(dateString) {
        const now = new Date();
        const date = new Date(dateString);
        const diffInSeconds = Math.floor((now - date) / 1000);

        if (diffInSeconds < 60) {
            return 'เมื่อสักครู่';
        } else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes} นาทีที่แล้ว`;
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours} ชั่วโมงที่แล้ว`;
        } else {
            const days = Math.floor(diffInSeconds / 86400);
            return `${days} วันที่แล้ว`;
        }
    }

    /**
     * ใช้ filter กับ notifications
     */
    applyFilter(filter) {
        this.currentFilter = filter;
        
        // อัพเดท label
        const filterLabels = {
            'all': 'ทั้งหมด',
            'commented': 'ความคิดเห็น',
            'created': 'สร้างใหม่',
            'updated': 'อัพเดท',
            'assigned': 'มอบหมาย',
            'state_changed': 'เปลี่ยนสถานะ',
            'member_removed': 'ลบสมาชิก',
            'deleted': 'ลบ',
            'restored': 'กู้คืน'
        };
        
        const label = filterLabels[filter] || 'ทั้งหมด';
        $('#filter-label').text(label);
        
        // รีเซ็ตและโหลดใหม่
        this.notifications.my = [];
        this.currentPage.my = 1;
        this.hasMorePages.my = true;
        this.loadNotifications();
    }
}

// default_js.php โหลดไฟล์นี้ทุกหน้ารวมหน้า login ที่ยังไม่มี session — ถ้า init ที่นั่นด้วย
// request จะได้ 401 แล้ว interceptor กลางเด้ง toast ใส่หน้า login ทั้งที่ผู้ใช้ยังไม่ได้ทำอะไรผิด
// กระดิ่งแจ้งเตือนอยู่ใน navbar ซึ่งมีเฉพาะหน้าที่ผ่าน auth แล้ว จึงใช้เป็นตัวชี้ว่าควร init ไหม
function shouldInitNotifications(doc) {
    return Boolean(doc.getElementById('notification-badge'));
}

// เริ่มต้นใช้งานเมื่อ DOM พร้อม
$(document).ready(function () {
    if (!shouldInitNotifications(document)) {
        return;
    }

    // เริ่มต้นใช้งาน notification system
    window.notificationManager = new NotificationManager();
    window._moduleNotifications = window.notificationManager;
});
